import { MpnDashboard } from "../features/mpn-dashboard";

const Dashboard = () => <MpnDashboard />;

export default Dashboard;
